import { CARD_COUNT } from '@tarot/shared';

/** 78장 전체를 섞은 카드 id 배열 — 펼쳐놓기용 (Fisher-Yates, crypto RNG) */
export function shuffleDeck(): number[] {
  const arr = Array.from({ length: CARD_COUNT }, (_, i) => i);
  const rnd = new Uint32Array(CARD_COUNT);
  crypto.getRandomValues(rnd);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = rnd[i]! % (i + 1);
    [arr[i], arr[j]] = [arr[j]!, arr[i]!];
  }
  return arr;
}

/** 정/역방향 랜덤 — 실제 덱처럼 뽑는 순간까지 방향을 알 수 없음 */
export function randomReversed(): boolean {
  const b = new Uint8Array(1);
  crypto.getRandomValues(b);
  return b[0]! % 2 === 1;
}
